import { FormattedMessage } from "react-intl";
import NavItem, { type Variant } from "./NavItem";
import { LinkExternal01Icon } from "@/icons";
import { useMatches } from "react-router";
import { isRecord } from "@/utils/helpers";

interface Props {
  vertical?: boolean;
  variant?: Variant;
  extended?: boolean;
}

export default function NavItems({
  vertical = false,
  variant = "primary",
  extended = false,
}: Props) {
  const matches = useMatches();
  const areWorkspacesActive = matches.some(
    // Workspace layout inserts a `workspace` property in their handle to signal the NavItem here should be active
    (match) => isRecord(match.handle) && match.handle["workspace"],
  );

  return (
    <>
      <NavItem
        to="/challenges"
        vertical={vertical}
        variant={variant}
        fullWidthIndicator={false}
      >
        <FormattedMessage defaultMessage="Challenges" />
      </NavItem>
      <NavItem
        to={`/datasets`}
        vertical={vertical}
        variant={variant}
        fullWidthIndicator={false}
      >
        <FormattedMessage defaultMessage="Datasets" />
      </NavItem>
      <NavItem
        to={`/workspaces`}
        vertical={vertical}
        variant={variant}
        fullWidthIndicator={false}
        isActive={areWorkspacesActive || undefined}
      >
        <FormattedMessage defaultMessage="Workspaces" />
      </NavItem>
      <NavItem
        to={`/papers`}
        vertical={vertical}
        variant={variant}
        fullWidthIndicator={false}
      >
        <FormattedMessage defaultMessage="Papers" />
      </NavItem>
      <NavItem
        to={`/discussions`}
        vertical={vertical}
        variant={variant}
        fullWidthIndicator={false}
      >
        <FormattedMessage defaultMessage="Discussions" />
      </NavItem>
      <NavItem
        to={`/leaderboard`}
        vertical={vertical}
        variant={variant}
        fullWidthIndicator={false}
      >
        <FormattedMessage defaultMessage="Leaderboard" />
      </NavItem>
      {extended && (
        <>
          <NavItem
            to={`/blog`}
            vertical={vertical}
            variant={variant}
            fullWidthIndicator={false}
          >
            <FormattedMessage defaultMessage="Blog" />
          </NavItem>
          {import.meta.env.VITE_QUANTUM_JOBS && (
            <NavItem
              to={import.meta.env.VITE_QUANTUM_JOBS}
              target="_blank"
              vertical={vertical}
              variant={variant}
              fullWidthIndicator={false}
              icon={<LinkExternal01Icon />}
            >
              <FormattedMessage defaultMessage="Job Board" />
            </NavItem>
          )}
          {import.meta.env.VITE_Q3AS && (
            <NavItem
              to={import.meta.env.VITE_Q3AS}
              target="_blank"
              variant={variant}
              vertical={vertical}
              fullWidthIndicator={false}
              icon={<LinkExternal01Icon />}
            >
              <FormattedMessage defaultMessage="Q3AS" />
            </NavItem>
          )}
        </>
      )}
    </>
  );
}
